import { cloneElement, FC } from "react";
import classNames from "classnames";
import { useTheme } from "@mui/material";

import styles from "./pulseAnimation.module.scss";

export interface PulseAnimationProps {
  children: React.ReactElement;
  stop?: boolean;
  variant?: "default" | "info" | "warning";
}

const PulseAnimation: FC<PulseAnimationProps> = (props: PulseAnimationProps) => {
  const { children, stop = false, variant = "default" } = props;
  const theme = useTheme();
  const contrastColor = theme.palette.primary.contrastText;

  return stop
    ? cloneElement(children, {
        className: classNames(children.props.className, {
          [styles.defaultWhite]: variant === "default" && contrastColor === "#fff",
          [styles.defaultBlack]: variant === "default" && contrastColor === "rgba(0, 0, 0, 0.87)",
          [styles.info]: variant === "info",
          [styles.warning]: variant === "warning",
        }),
      })
    : cloneElement(children, {
        className: classNames(children.props.className, {
          [styles.defaultWhiteAnimation]: variant === "default" && contrastColor === "#fff",
          [styles.defaultBlackAnimation]: variant === "default" && contrastColor === "rgba(0, 0, 0, 0.87)",
          [styles.infoAnimation]: variant === "info",
          [styles.warningAnimation]: variant === "warning",
        }),
      });
};

export default PulseAnimation;
